import Loader from 'react-loaders'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useRef, useState } from 'react'
import emailjs from '@emailjs/browser'

const Contact = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    const refForm = useRef()

    useEffect(() => {
            const timeoutId = setTimeout(() => {
                setLetterClass('text-animate-hover')
            }, 2500)
    
            return () => clearTimeout(timeoutId)
    
        }, [])

    const sendEmail = (e) => {
        e.preventDefault()

        emailjs.sendForm(
            'service_yq4ohvi',
            'template_dk2x1wp',
            refForm.current,
            '2X0jNIPzqIY8JFdx4'
        )
        .then(
            () => {
                alert('Message Sent!')
                window.location.reload(false)
            },
            () => {
                alert('Failed to send, try again in a little bit.')
            }
        )
    }

    return (
    <>
        <div className='container contact-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters letterClass={letterClass} 
                    strArray={['R', 'e', 'a', 'c', 'h', ' ', 'o', 'u', 't']} 
                    idx={15}/>
                </h1>
                <p>
                    Feel free to reach out if you want to connect. I'm always open to new conversations whether it be about shared interests, new oppurtunities, or anything else!
                </p>
                <div className='contact-form'>
                    <form ref={refForm} onSubmit={sendEmail}>
                        <ul>
                            <li className='half'>
                                <input type='text' name='name' placeholder='Name' required />        
                            </li>
                            <li className='half'>
                                <input type='email' name='email' placeholder='Email' required/>
                            </li>
                            <li>
                                <input placeholder='Subject' type='text' name='subject' required/>
                            </li>
                            <li>
                                <textarea placeholder='Message' name='message' required></textarea>
                            </li>
                            <li>
                            <input type='submit' className='flat-button' value='SEND'/>
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
        <Loader type='pacman' />
    </>
    )
}

export default Contact